module.exports = " <div class=column :class=classes _v-fed32162=\"\"> <slot _v-fed32162=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-fed32162!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Column.vue
// module id = 768
// module chunks = 2